import React from 'react';
import HeroSlideshow from '../components/HeroSlideshow';
import Screenshots from '../components/Screenshots';
import StoreButtons from '../components/StoreButtons';
import { heroImages } from '../data/media';
import './Home.css';

const FEATURES = [
  {
    title: 'İnteraktif Harita',
    text: 'İstanbul’un tarihî ve turistik noktalarını harita üzerinde görün, çevrenizdekini keşfedin.',
    icon: (
      <>
        <path d="M12 21s-7-5.686-7-11a7 7 0 1 1 14 0c0 5.314-7 11-7 11Z" />
        <circle cx="12" cy="10" r="2.6" />
      </>
    ),
  },
  {
    title: 'Sesli Anlatım',
    text: 'Her mekânın hikâyesini kulaklığınızdan dinleyin; gezerken okumak zorunda kalmayın.',
    icon: (
      <>
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <path d="M4 14h2.2a1 1 0 0 1 1 1v3.5a1 1 0 0 1-1 1H5.5A1.5 1.5 0 0 1 4 18V14Z" />
        <path d="M20 14h-2.2a1 1 0 0 0-1 1v3.5a1 1 0 0 0 1 1h.7A1.5 1.5 0 0 0 20 18V14Z" />
      </>
    ),
  },
  {
    title: 'Video İçerikler',
    text: 'Mekânların video turlarıyla gezinizi önceden planlayın, neyi göreceğinizi bilin.',
    icon: (
      <>
        <rect x="3" y="6" width="13" height="12" rx="2.5" />
        <path d="M16 10.5 21 8v8l-5-2.5v-3Z" />
      </>
    ),
  },
  {
    title: 'Tarihî ve Güncel Kareler',
    text: 'Aynı yapının arşiv fotoğrafı ile bugünkü hâlini karşılaştırın, değişimi görün.',
    icon: (
      <>
        <rect x="3" y="7" width="18" height="13" rx="2.5" />
        <path d="M8 7 9.5 4h5L16 7" />
        <circle cx="12" cy="13.5" r="3.2" />
      </>
    ),
  },
];

const FeatureIcon = ({ children }) => (
  <svg
    viewBox="0 0 24 24"
    width="26"
    height="26"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <HeroSlideshow images={heroImages} />

        <div className="hero__inner container">
          <p className="hero__eyebrow">Travel Istanbul</p>
          <h1 className="hero__title">
            İstanbul’u,
            <br />
            hikâyesiyle gezin
          </h1>
          <p className="hero__subtitle">
            Şehrin tarihî yapılarını, camilerini ve eserlerini sesli anlatım, interaktif
            harita ve arşiv fotoğraflarıyla keşfedin.
          </p>

          <StoreButtons variant="light" align="center" />

          <ul className="hero__meta">
            <li>Sesli anlatım</li>
            <li>İnteraktif harita</li>
            <li>Arşiv ve güncel fotoğraflar</li>
          </ul>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features__head">
            <p className="eyebrow">Neler var</p>
            <h2 className="section-title">Rehberi cebinizde taşıyın</h2>
            <span className="rule features__rule" />
          </div>

          <div className="features__grid">
            {FEATURES.map((feature) => (
              <article className="feature" key={feature.title}>
                <span className="feature__icon">
                  <FeatureIcon>{feature.icon}</FeatureIcon>
                </span>
                <h3 className="feature__title">{feature.title}</h3>
                <p className="feature__text">{feature.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Screenshots />

      <section className="cta">
        <div className="container cta__inner">
          <div className="cta__copy">
            <p className="eyebrow">Hazır mısınız</p>
            <h2 className="section-title">Uygulamayı indirin, yola çıkın</h2>
            <p className="section-lead">
              Travel Istanbul’u telefonunuza kurun; gezinizi ilk mekândan itibaren
              hikâyesiyle birlikte yaşayın.
            </p>
          </div>
          <StoreButtons variant="dark" align="start" />
        </div>
      </section>
    </div>
  );
};

export default Home;
